<template>
  <div class="Services" style="background-color: #f0f2f5">
    <b-row>
      <b-col class="mx-auto" cols="8">
        <b-input-group class="mt-3">
          <div class="form-group mb-3 input-group input-text-wrapper">
            <div class="input-group-prepend">
              <span
                class="input-group-text"
                style="
                  background-color: #ffffff;
                  border: none;
                  border-radius: 30px;
                "
              >
                <font-awesome-icon icon="search" style="color: #ced4da" />
              </span>
            </div>
            <b-form-input
              class="name-search-text-input"
              type="text"
              v-model="name"
              required
              placeholder="Enter Service name to search"
            ></b-form-input>

            <b-input-group-append>
              <button @click="search_service" class="public-name-search-button">
                Search
                <b-spinner
                  v-if="serviceSearchSpinner"
                  small
                  label="Loading..."
                ></b-spinner>
              </button>
            </b-input-group-append>
          </div>
        </b-input-group>

        <b-row>
          <b-col>
            <b-button
              style="
                width: 33%;
                height: 70px;
                background-color: #000000;
                color: #ffffff;
                border: none;
                box-shadow: none !important;
              "
              squared
              @click="openPage('licence_application')"
            >
              LICENCE APPLICATIONS
            </b-button>
            <b-button
              style="
                width: 34%;
                height: 70px;
                background-color: #f7f700;
                color: #000000;
                border: none;
                box-shadow: none !important;
              "
              squared
              @click="openPage('government_services')"
              id="defaultOpen"
            >
              GOVERNMENT SERVICES
            </b-button>
            <b-button
              style="
                width: 33%;
                height: 70px;
                background-color: #db0000;
                color: #ffffff;
                border: none;
                box-shadow: none !important;
              "
              squared
              @click="openPage('postal_services')"
            >
              POSTAL SERVICES</b-button
            >

            <div
              style="background-color: #000000; color: #ffffff"
              id="licence_application_content"
              v-if="licence_application"
            ></div>

            <div
              style="background-color: #f7f700"
              id="government_services_content"
              v-if="government_services"
            >
              <br />
              <b-list-group class="mx-auto" style="width: 90%">
                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Request For Mail Delivery
                  <b-button
                    style="color: #000000; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Passport Delivery
                  <span
                    ><small class="mr-16">(IMMIGRATION)</small>
                    <b-button
                      style="color: #000000; text-decoration: none"
                      variant="link"
                      ><b>Apply</b></b-button
                    >
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  National ID Delivery
                  <span>
                    <small class="mr-16">(NIRA)</small>
                    <b-button
                      style="color: #000000; text-decoration: none"
                      variant="link"
                      ><b>Apply</b></b-button
                    >
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Verification Documents Delivery
                  <span
                    ><small class="mr-16">(NIRA)</small>
                    <b-button
                      style="color: #000000; text-decoration: none"
                      variant="link"
                      ><b>Apply</b></b-button
                    >
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Death Certificate Delivery
                  <span
                    ><small class="mr-16">(NIRA)</small>
                    <b-button
                      style="color: #000000; text-decoration: none"
                      variant="link"
                      ><b>Apply</b></b-button
                    >
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Birth Certificate Delivery
                  <span
                    ><small class="mr-16">(NIRA)</small>
                    <b-button
                      style="color: #000000; text-decoration: none"
                      variant="link"
                      ><b>Apply</b></b-button
                    >
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Company Documents Delivery
                  <span
                    ><small class="mr-16">(URSB)</small>
                    <b-button
                      style="color: #000000; text-decoration: none"
                      variant="link"
                      ><b>Apply</b></b-button
                    >
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Alien ID Delivery
                  <span
                    ><small class="mr-16">(NIRA)</small>
                    <b-button
                      style="color: #000000; text-decoration: none"
                      variant="link"
                      ><b>Apply</b></b-button
                    >
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Driving Permit Delivery
                  <span
                    ><small class="mr-16">(MIN-WORKS)</small>
                    <b-button
                      style="color: #000000; text-decoration: none"
                      variant="link"
                      ><b>Apply</b></b-button
                    >
                  </span>
                </b-list-group-item>

                <b-list-group-item
                  class="government_data_style d-flex justify-content-between align-items-center py-3"
                >
                </b-list-group-item>
              </b-list-group>
              <br />
            </div>

            <div
              style="background-color: #db0000; color: #ffffff"
              id="postal_services_content"
              v-if="postal_services"
            >
              <br />
              <b-list-group class="mx-auto" style="width: 90%">
                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Virtual Postal Address
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Physical Postal Address
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Renew Postal Address
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Request For Delivery
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Track Your Items
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Update Your Postal Address Details
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Your Mails Inbox
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Delivery Request Status
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-1"
                >
                  Online Application Status
                  <b-button
                    style="color: #ffffff; text-decoration: none"
                    variant="link"
                    ><b>Apply</b></b-button
                  >
                </b-list-group-item>

                <b-list-group-item
                  class="postal_data_style d-flex justify-content-between align-items-center py-3"
                >
                </b-list-group-item>
              </b-list-group>
              <br />
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "EpostaServices",
  data() {
    return {
      serviceSearchSpinner: false,
      licence_application: false,
      government_services: false,
      postal_services: true,
    };
  },
  methods: {
    search_service() {
      alert("do search services");
    },
    openPage(page) {
      if (page === "licence_application") {
        this.licence_application = true;
        this.government_services = false;
        this.postal_services = false;
      } else if (page === "government_services") {
        this.licence_application = false;
        this.government_services = true;
        this.postal_services = false;
      } else if (page === "postal_services") {
        this.licence_application = false;
        this.government_services = false;
        this.postal_services = true;
      }
    },
  },
};
</script>

<style scoped>
.Services {
  width: 100%;
  height: 100%;
  /* background-color: #c40000;*/
  background-size: cover;
}

.serviceCards {
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 30px 30px 30px 30px;
  padding-left: 2px;
  background-color: #ffffff;
}

.name-search-text-input {
  border: none;
  height: 50px;
  color: #8898aa;
  width: 100px;
  outline: none;
  box-shadow: none !important;
}

.public-name-search-button {
  background: #db0000;
  border: none;
  color: #ffffff;
  text-align: center;
  width: 110px;
  border-radius: 0px 30px 30px 0px;
}

.box {
  border-radius: 6px;
  margin-right: 50px;
  margin-left: 50px;
  margin-top: 40px;
  box-shadow: 8px 10px 28px #9f0012;
}

.left {
  width: 50%;
  height: inherit;
  background-color: #f1f1f1;
  background-size: cover;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.right {
  width: 50%;
  height: inherit;
  background-color: #f1f1f1;
  background-size: cover;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.title-bar {
  background: #db0000;
  padding: 15px;
}

.links {
  text-decoration: none;
  color: #fff;
  list-style: none;
}

.links li {
  padding: 5px;
  display: inline;
}

.links .active {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

.links li:hover {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

li a {
  color: white;
  text-decoration: none;
}

.logo {
  width: 100px;
  height: 30px;
}

/* Style tab links */
.tablink {
  color: white;
  border: none;
  float: left;
  cursor: pointer;
  padding: 14px 16px;
  font-size: 17px;
  width: 25%;
}

.tablink:hover {
  background-color: #777;
}

/* Style the tab content (and add height:100% for full page content) */
.tabcontent {
  color: white;
  display: none;
  padding: 100px 20px;
  height: 100%;
}

.postal_data_style {
  background-color: #db0000;
  color: #ffffff;
  border: 1px solid #ffffff;
}

.government_data_style {
  background-color: #f7f700;
  color: #000000;
  border: 1px solid #000000;
}
</style>
